
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VaccineApi } from '../api/vaccine.api';
import { switchMap, map } from 'rxjs/operators';

import { VaccineData, Vaccine } from '../../../interfaces/masters/vaccine' ;
@Injectable()
export class VaccineService extends VaccineData {

    constructor(private api: VaccineApi) {
      super();
    }
  
  
    list(url: string): Observable<Vaccine[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<Vaccine>{
        return this.api.getById(url);
    }
  
    create(url: string, data:Vaccine): Observable<Vaccine[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:Vaccine): Observable<Vaccine> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  